import { useLocation, useNavigate } from "react-router-dom";
import "./otp.css";
import React, { useState, ChangeEvent, FormEvent, useEffect, useRef } from "react";
import { getSurveyById } from "../../../../api/services/survey-apis";
import { createOTP, validateOTP } from "../../../../api/services/otp-apis";
import "bootstrap/dist/css/bootstrap.min.css";
import { toast } from "react-toastify";

function generateId() {
  return Math.floor(100000 + Math.random() * 900000).toString();
}

// const Otp: React.FC = () => {
//   const [email, setEmail] = useState("");
//   const [requestId, setRequestId] = useState("");
//   const [otp, setOtp] = useState("");
//   const otpSentRef = useRef(false);
//   const isProcessing = useRef(false); // Add flag to prevent concurrent calls
//   const navigate = useNavigate();
//   const location = useLocation();

//   const surveyId = new URLSearchParams(location.search).get("surveyId");

//   // Single effect: generate requestId, fetch email, and send OTP once
//   useEffect(() => {
//       const urlParams = new URLSearchParams(location.search);
//       const currentSurveyId = urlParams.get("surveyId");
//     if (surveyId && !otpSentRef.current && !isProcessing.current) {
//       console.log("=== OTP Effect Triggered ===");
//       otpSentRef.current = true;
//       isProcessing.current = true;
      
//       const id = generateId();
//       setRequestId(id);
//       console.log("Generated ID:", id);
      
//       // Fetch email and send OTP
//       console.log(`[${new Date().toISOString()}] Starting OTP process for surveyId: ${currentSurveyId} with requestId: ${id}`);
//       // fetchEmailAndSendOtp(surveyId, id);
//     }
//   }, []);

//   const fetchEmailAndSendOtp = async (surveyId: string, id: string) => {
//     try {
//       console.log(`[${new Date().toISOString()}] Fetching email for surveyId: ${surveyId}`);
//       const response = await getSurveyById(surveyId);
//       const fetchedEmail = response.data.email;
//       setEmail(fetchedEmail);
//       console.log("Fetched email:", fetchedEmail);

//       // Send OTP after fetching email
//       const createOtpPayload = {
//         requestId: id,
//         surveyId,
//       };

//       console.log(`[${new Date().toISOString()}] Calling createOTP API with:`, createOtpPayload);
//       await createOTP(createOtpPayload);
//       console.log(`[${new Date().toISOString()}] OTP API call completed for:`, fetchedEmail);
//       toast.success("OTP sent successfully!");
//     } catch (error) {
//       console.error("Error fetching email or sending OTP:", error);
//       toast.error("Error sending OTP");
//       otpSentRef.current = false;
//       isProcessing.current = false; // Reset on error to allow retry
//     }
//   };

//   const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
//     setOtp(e.target.value);
//   };

//   const handleSubmit = async (e: FormEvent) => {
//     const validateOtpPayload = {
//       requestId,
//       otpValue: otp,
//     };

//     e.preventDefault();
//     console.log("RequestID:", requestId);
//     console.log("Generated RequestID:", requestId);

//     try {
//       const response = await validateOTP(validateOtpPayload);
//       console.log("OTP Validation Response:", response.data);

//       if (response.data.requestId && response.data.surveyId) {
//         navigate(`/survey?surveyId=${surveyId}`, {
//           state: { surveyId: response.data.surveyId },
//         });
//       } else {
//         toast.error("Wrong OTP. Please try again.");
//       }
//     } catch (error) {
//       console.error("Error validating OTP:", error);
//       toast.error("Wrong OTP. Please try again.");
//     }

//     console.log("otp entered", otp);
//   };

//   return (
//     <div className="otp-container">
//       <div className="otp-content">
//         <h3>We have sent an OTP to your email</h3>
//         <p>Please enter the OTP below:</p>
//         <form onSubmit={handleSubmit}>
//           <input
//             type="text"
//             value={otp}
//             onChange={handleInputChange}
//             placeholder="Enter OTP"
//             className="otp-input"
//           />
//           <br />
//           <button type="submit" className="otp-submit-button">
//             Submit
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default Otp;
const Otp: React.FC = () => {
  const [email, setEmail] = useState("");
  const [requestId, setRequestId] = useState("");
  const [otp, setOtp] = useState("");
  const otpSentRef = useRef(false);
  const isProcessing = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Single effect: generate requestId, fetch email, and send OTP once
  useEffect(() => {
    // Only run if not already sent
    if (otpSentRef.current || isProcessing.current) {
      console.log("=== OTP Already Sent or Processing - Skipping ===");
      return;
    }

    const urlParams = new URLSearchParams(location.search);
    const currentSurveyId = urlParams.get("surveyId");
    
    if (!currentSurveyId) {
      console.log("=== No surveyId in URL - Skipping ===");
      return;
    }

    console.log("=== OTP Effect Triggered ===");
    console.log("Location search:", location.search);
    
    // Set flags IMMEDIATELY before any async operations
    otpSentRef.current = true;
    isProcessing.current = true;
    
    const id = generateId();
    setRequestId(id);
    console.log("Generated ID:", id);
    
    // Fetch email and send OTP
    fetchEmailAndSendOtp(currentSurveyId, id);
  }, [location.search]); // Add location.search as dependency

  const fetchEmailAndSendOtp = async (surveyId: string, id: string) => {
    try {
      console.log(`[${new Date().toISOString()}] Fetching email for surveyId: ${surveyId}`);
      const response = await getSurveyById(surveyId);
      const fetchedEmail = response.data.email;
      setEmail(fetchedEmail);
      console.log("Fetched email:", fetchedEmail);

      // Send OTP after fetching email
      const createOtpPayload = {
        requestId: id,
        surveyId,
      };

      console.log(`[${new Date().toISOString()}] Calling createOTP API with:`, createOtpPayload);
      await createOTP(createOtpPayload);
      console.log(`[${new Date().toISOString()}] OTP API call completed for:`, fetchedEmail);
      toast.success("OTP sent successfully!");
    } catch (error) {
      console.error("Error fetching email or sending OTP:", error);
      toast.error("Error sending OTP");
      // Reset flags on error to allow retry
      otpSentRef.current = false;
      isProcessing.current = false;
    }
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setOtp(e.target.value);
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    
    const validateOtpPayload = {
      requestId,
      otpValue: otp,
    };

    console.log("Validating OTP with RequestID:", requestId);

    try {
      const response = await validateOTP(validateOtpPayload);
      console.log("OTP Validation Response:", response.data);

      if (response.data.requestId && response.data.surveyId) {
        const surveyId = response.data.surveyId;
        navigate(`/survey?surveyId=${surveyId}`, {
          state: { surveyId },
        });
      } else {
        toast.error("Wrong OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error validating OTP:", error);
      toast.error("Wrong OTP. Please try again.");
    }
  };

  // Get surveyId for display only
  const currentSurveyId = new URLSearchParams(location.search).get("surveyId");

  return (
    <div className="otp-container">
      <div className="otp-content">
        <h3>We have sent an OTP to your email</h3>
        <p>Please enter the OTP below:</p>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={otp}
            onChange={handleInputChange}
            placeholder="Enter OTP"
            className="otp-input"
          />
          <br />
          <button type="submit" className="otp-submit-button">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default Otp;